import '../css/BrowserMenuMock.css';
import TapMarker from './TapMarker';
import { EXTERNAL_BROWSER_GUIDE_MENU_ITEMS } from '../constants/bookingConst';

/**
 * Picture of the menu the in-app browser's ••• button opens on iOS: a
 * floating glass sheet over the dimmed page, in the style of iOS 26, with
 * "Open in external browser" highlighted and a tap marker outlining the
 * whole row.
 *
 * The rows come from EXTERNAL_BROWSER_GUIDE_MENU_ITEMS; only the first is
 * the one to tap, the rest are there so the picture reads as that menu.
 *
 * @returns {JSX.Element}
 */
function BrowserMenuMock() {
  return (
    <div className="bmm-mock" aria-hidden="true">
      <div className="bmm-page">
        <span className="bmm-block bmm-block--hero" />
        <span className="bmm-block" />
      </div>

      <div className="bmm-sheet">
        <span className="bmm-grabber" />
        <ul className="bmm-list">
          {EXTERNAL_BROWSER_GUIDE_MENU_ITEMS.map((item, index) => {
            const isTarget = index === 0;
            return (
              <li key={item} className={`bmm-item${isTarget ? ' bmm-item--target' : ''}`}>
                <span className="bmm-item-text">{item}</span>
                {isTarget && <TapMarker shape="outline" />}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default BrowserMenuMock;
